import { render } from "./loading-spinner.vue?vue&type=template&id=4665d25a&scoped=true"
const script = {}

import "./loading-spinner.vue?vue&type=style&index=0&id=4665d25a&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4665d25a"]])

export default __exports__